import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { msg } from 'api';

export default class Disclaimer extends PureComponent {
  static propTypes = {
    deliverySlot: PropTypes.object,
    disclaimerRegularMessage: PropTypes.string,
    priceMessageType: PropTypes.string,
    showLifeDisclaimer: PropTypes.bool,
  };

  render() {
    const { deliverySlot, disclaimerRegularMessage, priceMessageType, showLifeDisclaimer } = this.props;
    return (
      <>
        {showLifeDisclaimer && (
          <>
            <h6>Life guarantee</h6>
            {showLifeDisclaimer && <p className="gn-content__caption">{msg.product.disclaimer.life}</p>}
            {showLifeDisclaimer && !deliverySlot &&
            <p className="gn-content__caption">{msg.product.disclaimer.lifeNoSlot}</p>}
            <p className="gn-content__caption">
              {msg.product.disclaimer.termsAndConditions.see}{' '}
              <a href={msg.product.disclaimer.termsAndConditions.href}>
                {msg.product.disclaimer.termsAndConditions.linkLabel}
              </a>{msg.product.disclaimer.termsAndConditions.furtherDetails}
            </p>
          </>
        )}
        <h6>Disclaimer</h6>
        {priceMessageType === 'TYPICAL_REGULAR' &&
          <p className="gn-content__caption">{msg.product.disclaimer.catchWeight}</p>
        }
        <p className="gn-content__caption">{disclaimerRegularMessage || msg.product.disclaimer.regularMessage}</p>
      </>
    );
  }
}
